import { render, staticRenderFns } from "./DeepSeekAi.vue?vue&type=template&id=6842d7b6&scoped=true"
import script from "./DeepSeekAi.vue?vue&type=script&lang=js"
export * from "./DeepSeekAi.vue?vue&type=script&lang=js"
import style0 from "./DeepSeekAi.vue?vue&type=style&index=0&id=6842d7b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842d7b6",
  null
  
)

export default component.exports